import Abstract from "./../../abstract-view/abstract.js";
import Animation from "./../../animation/animation.js";

export default class Pin extends Abstract {
  constructor(element, id) {
    super();

    this._element = element;
    this._id = id;
    this._animationComponent = new Animation();

    this._buttonElement = null;
    this._detailsElement = null;

    this._setButtonElement();
    this._setDetailsElement();

    this._elementMouseenterHandler = this._elementMouseenterHandler.bind(this);
    this._elementMouseleaveHandler = this._elementMouseleaveHandler.bind(this);
    this._elementClickHandler = this._elementClickHandler.bind(this);
  }

  open() {
    this._element.classList.add(`images-pin-item_active`);
    this._buttonElement.classList.add(`images-pin-item__button_active`);

    this._animationComponent.fadeIn(
        this._detailsElement
    );
  }

  close() {
    this._element.classList.remove(`images-pin-item_active`);
    this._buttonElement.classList.remove(`images-pin-item__button_active`);

    this._animationComponent.fadeOut(
        this._detailsElement
    );
  }

  setElementMouseenterHandler(callback) {
    this._callback.elementMouseenter = callback;

    this._buttonElement.addEventListener(`mouseenter`, this._elementMouseenterHandler);
  }

  setElementMouseleaveHandler(callback) {
    this._callback.elementMouseleave = callback;

    this._buttonElement.addEventListener(`mouseleave`, this._elementMouseleaveHandler);
  }

  setElementClickHandler(callback) {
    this._callback.elementClick = callback;

    this._buttonElement.addEventListener(`click`, this._elementClickHandler);
  }

  _elementMouseenterHandler() {
    this._callback.elementMouseenter(this._id);
  }

  _elementMouseleaveHandler() {
    this._callback.elementMouseleave(this._id);
  }

  _elementClickHandler() {
    this._callback.elementClick(this._id);
  }

  _setButtonElement() {
    if (!this._buttonElement) {
      this._buttonElement = this._element.querySelector(`.images-pin-item__button`);
    }
  }

  _setDetailsElement() {
    if (!this._detailsElement) {
      this._detailsElement = this._element.querySelector(`.images-pin-details`);
    }
  }
}
